var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.METAFIELD_FRAGMENT = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.METAFIELD_FRAGMENT = (0, graphql_tag_1.default) `
  fragment MetafieldFragment on Metafield {
    id
    key
    namespace
    value
    valueType
  }
`;
//# sourceMappingURL=metafieldFragment.js.map